const items = [
  {
    id: 1,
    title: 'Working title',
    url: 'https://www.google.com',
    description: 'This is a description',
    topics: ['javascript', 'react', 'node'],
  },
  {
    id: 2,
    title: 'Twerking title',
    url: 'https://www.goooogle.com',
    description: 'This is a description of twerking',
    topics: ['javascript'],
  },
  {
    id: 3,
    title: 'BWorking title',
    url: 'https://www.google.com',
    description: 'This is a description',
    topics: ['java', 'react', 'node'],
  },
  {
    id: 4,
    title: 'CWorking title',
    url: 'https://www.google.com',
    description: 'This is a description',
    topics: ['java'],
  },
]

export default items
